{ "imageTag": "20261103205707_07aceb5", "buildUri": "vstfs:///Build/Build/103949", "buildId": "103949", "sourceCommit": "07aceb5b7d4938c8845544086c22421fa76c697c", "sourceBranch": "main", "releaseDate": "2026-11-03T21:02:56Z" }
